import React from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Lucila Guzmán",
    role: "1 opinión",
    text: "Son muy amables y te brindan la mejor atención.",
    initials: "LG",
    color: "var(--cima-red)",
  },
  {
    name: "Jorge Monge",
    role: "Local Guide · 72 opiniones · 92 fotos",
    text: "Excelente atención.",
    initials: "JM",
    color: "var(--cima-navy)",
    featured: true,
  },
  {
    name: "Germán Cadena",
    role: "3 opiniones",
    text: "Excelente atención a domicilio.",
    initials: "GC",
    color: "var(--cima-orange)",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonios" data-testid="testimonials-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="divider-orange mb-5" />
          <p className="font-mono-cima text-xs uppercase tracking-widest text-[var(--cima-red)] mb-3">
            Testimonios reales
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight text-[var(--cima-navy)]">
            Lo que opinan nuestros clientes
          </h2>
          <p className="mt-4 text-slate-600">
            Opiniones reales publicadas por clientes en Google Maps sobre nuestra atención y servicio.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className={`relative border ${
                t.featured ? "border-[var(--cima-navy)]" : "border-slate-300"
              } bg-white p-7 flex flex-col`}
            >
              <Quote className="w-8 h-8 text-[var(--cima-orange)]/40 mb-4" />
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[var(--cima-orange)] text-[var(--cima-orange)]" />
                ))}
              </div>
              <p className="text-base text-slate-700 leading-relaxed flex-1">
                “{t.text}”
              </p>
              <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
                <div
                  className="w-11 h-11 flex items-center justify-center text-white font-display font-bold text-sm"
                  style={{ background: t.color }}
                >
                  {t.initials}
                </div>
                <div>
                  <div className="font-display font-semibold text-[var(--cima-navy)] leading-tight">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5">{t.role}</div>
                </div>
              </div>
              {t.featured && (
                <div className="absolute -top-3 left-6 bg-[var(--cima-navy)] text-white text-[10px] font-mono-cima uppercase tracking-widest px-2.5 py-1">
                  Local Guide
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
